'use client'

import { useImpersonationStatus } from '@/Auth/useImpersonationStatus'

/**
 * True when an admin is impersonating the current storefront user.
 * Used to skip "must have purchased" gates that the API also relaxes for active impersonation.
 */
export function useImpersonationReviewBypass(): boolean {
  const { isImpersonatingCurrentUser } = useImpersonationStatus()
  return isImpersonatingCurrentUser
}
